<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        cols="12"
        :md="selectItem ? '8' : '12'"
        class="table-detail">
        <v-data-table
          :headers="header"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
          class="w-full"
          @update:options="getData()"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <span class="capitalize"> Webhook Logs </span>
              </v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical />
              <v-spacer />
              <v-autocomplete
                v-model.trim="selectType"
                :items="allWebhookType"
                class="mb-2 mr-5 search-text-field"
                label="Type"
                item-text="text"
                item-value="value"
                hide-details
                @change="getData()" />
            </v-toolbar>
          </template>

          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | dateTimeFormat() }}
          </template>

          <template #[`item.type`]="{ item }">
            {{ getItemType(item.type) }}
          </template>
          <template #[`item.responseTime`]="{ item }">
            {{ item.responseTime ? `${item.responseTime}ms` : '-' }}
          </template>
          <template #[`item.option`]="{ item }">
            <v-btn
              v-if="!selectItem || selectItem.id !== item.id"
              link
              icon
              x-small
              @click="showItemDetail(item)">
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        v-if="selectItem"
        cols="12"
        md="4"
        class="pa-0">
        <div class="log-detail">
          <h3 class="text-bold mb-0">
            {{ selectItem.description }}
          </h3>
          <p class="mb-0">
            <b>Date </b>{{ selectItem.createdAt | dateTimeFormat() }}
          </p>
          <p class="mb-0">
            <b>ShopId </b> {{ selectItem.shopId }}
          </p>
          <p class="mb-0">
            <b>Timestamp </b> {{ selectItem.timestamp }}
          </p>
          <p
            ref="Response"
            class="mt-1">
            Raw data
          </p>
          <div style="border: 1px solid #000;">
            <json-viewer
              :value="selectItem.rawData"
              :expand-depth="2"
              copyable />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TiktokProvider from '@/resources/TiktokProvider'

const TiktokService = new TiktokProvider()

export default {
  components: {
    // BcLogDetail
  },
  data () {
    return {
      loading: false,
      selectItem: null,
      showDetail: false,
      total: 0,
      selectType: 0,
      allWebhookType: [
        {
        value: 0,
        text: 'All'
      },
      {
        value: 1,
        text: '(1) Order status change'
      },
      {
        value: 3,
        text: '(3) Recipient address update'
      },
      {
        value: 5,
        text: '(5) Product status change'
      },
      {
        value: 7,
        text: '(7) Upcoming authorization expiration'
      },
      {
        value: 11,
        text: '(11) Cancellation status change'
      },
      {
        value: 12,
        text: '(12) Return status change'
      },
      {
        value: 15,
        text: '(15) Product information change'
      },
      {
        value: 16,
        text: '(16) Product creation'
      },
      {
        value: 27,
        text: '(27) Inventory status change'
      },
      {
        value: 37,
        text: '(37) Product audit status change'
      }
    ],
      options: {
        page: 1,
        itemsPerPage: 15,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      header: [
        {
          text: 'Date',
          value: 'createdAt',
          sortable: false
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false
        },
        {
          text: 'ShopId',
          value: 'shopId',
          align: 'center',
          sortable: false
        },
        {
          text: 'Options',
          value: 'option',
          align: 'center'
        }
      ],
      items: []
    }
  },
  created () {
    this.getData(true)
  },
  methods: {
    showItemDetail (item) {
      this.selectItem = item
      this.showDetail = true
    },
    scrollTo (tag) {
      const el = this.$refs[tag]
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    getItemType (type) {
      const findType = this.allWebhookType.find((t) => t.value === type)
      return findType ? findType.text : type
    },
    async getData (clear = false) {
      if (clear) {
        this.options.page = 1
      }
      try {
        this.loading = true
        const { data: { results, total } } = await TiktokService.getWebhookLogs(
          {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            type: this.selectType
          }
        )

        this.items = results
        this.total = total
        if (clear && results.length !== 0) {
          this.selectItem = this.items[0]
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.table-detail {
  height: calc(100vh - 80px);
  overflow-y: auto;
  background-color: #fff;
}
.log-detail {
  width: 100%;
  margin-left: 10px;
  padding: 10px;
  height: 100%;
  overflow-y: auto;
  height: calc(100vh - 80px);
  background-color: #fff;
}
.method {
  padding: 4px;
  border-radius: 6px;
  width: 60px;
  text-align: center;
}
</style>
